import { Injectable } from '@angular/core';
import { DetailedEntityDataEditorService } from '../../../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-data-editor.service';
import { CoreServiceRegistry } from '../../../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../../../shared/shared-service-registry';
import { SearchParams } from '../../../../../../shared/search/models/search-params.model';
import { DataTableConfig } from '../../../../../../shared/search/models/data-table-config';


@Injectable()
export class ViewLocationDataEditorService extends DetailedEntityDataEditorService {


  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }
    // overriding this function for inventory adjustment lookup
    protected createLookupParamsForColumn(property: any) {
        const lookupParams: SearchParams = new SearchParams();
        lookupParams.isFullFetch = true;
        lookupParams.columnCount = 10;
        lookupParams.defaultSearchColumn = '';
        const tableConfig: DataTableConfig = new DataTableConfig();
        tableConfig.showIdAsAHyperLink = true;
        tableConfig.supportFiltering = true;
        lookupParams.dataTableConfig = tableConfig;
        if (property === 'storerKey') {
            lookupParams.tableId = 'storertd';
            lookupParams.idProperty = 'storerName';
        } else if (property === 'packKey') {
            lookupParams.tableId = 'packtd';
            lookupParams.idProperty = 'packKey';
        } else if (property === 'loc') {
            lookupParams.tableId = 'locationtd';
            lookupParams.idProperty = 'locId';
        }
        return lookupParams;
    }

  protected refreshAutoPopulatedLookupProperty(row: any, baseProperty: string,
    propertyMap: any, isStartEvent: boolean, hasError: boolean) {
    // if this is a start event
    let isLoading: boolean = false;
    if (isStartEvent && row.cells[baseProperty].cVal && row.cells[baseProperty].cVal !== '') {
      isLoading = true;
    }
    const dependantProps = Object.keys(propertyMap);
    dependantProps.forEach(property => {
      if (property !== baseProperty) {
        if (isStartEvent) {
          row.cells[property].cValPrev = row.cells[property].cVal;
          row.cells[property].cVal = '';
        }
        row.cells[property].isLoading = isLoading;
      }
    });
    if (!isLoading) {
      row.cells[baseProperty].isValueInvalid = hasError;
      const propToFocus = hasError ? baseProperty : this.getNextPropertyToFocus(baseProperty);
      let agGridApi;
      if (this.dataService.getSearchService()) {
        agGridApi = this.dataService.searchService.getPagedData().aggridApi;
      } else {
        agGridApi =  null;
      }
      const rowId = 0;
      if (agGridApi && agGridApi.getFocusedCell()) {
        agGridApi.setFocusedCell(agGridApi.getFocusedCell().rowIndex, propToFocus);
      } else {
        row.focusedCellId = propToFocus;
      }
    }
  }

  /**
   * method used to emit event when property value using lookup
   */
  public valueChanged(property, prevVal, currentValue) {
    if (prevVal === currentValue) {
      return;
    }
    const valueChangedObject = new Object();
    valueChangedObject['property'] = property;
    valueChangedObject['prevVal'] = prevVal;
    valueChangedObject['newVal'] = currentValue;
    this.dataService.valueChangedPublishEvent(valueChangedObject);

  }
  //LFWM-1973-Commodity Assign location type ahead issue
  protected getDependantMapForProperty(property: string) {
    let propMap: any;
    if (property === 'loc') {
        propMap = {
          'loc':'locId'
        };
    } else {
      propMap = {};
    }
    return propMap;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/commodity/commodity-home/popup/view-location-popup-data-editor.service.ts